// @flow

export const SAVE_CONFIG_MODAL_OPEN: 'listo/cart/saveConfig/modalOpen' = 'listo/cart/saveConfig/modalOpen';

export default null;
